(function ($, Drupal) {
    Drupal.behaviors.form_popup = {
        attach: function (context, settings) {

            // reset bodyclass on load
            $('body').removeClass('overlay-open');

            var overlay = '.overlay_1.cm_module';
            var previewbutton = '.form-wrapper .webform-button--preview:not(' + overlay + ' .webform-button--preview)';
            // no form preview button, nothing to do
            if (!$(previewbutton)[0]) {
                return;
            }

            // no datenschutzbox, nothing to do
            if (!$(overlay)[0]) {
                return;
            }

            // check for error in popup - e.g. not checked privacy
            // show popup
            if ($(overlay + ' input').hasClass('error')) {
                var notoverlay_errors = $('form input.error:not(' + overlay + ' input.error)').length;
                if (notoverlay_errors == 0) {  // no other errors on form input
                  var messages = $('.messages.type-error').clone();
                  $('.messages.type-error').remove();
                  $(messages).insertAfter('.overlay_popup .overlay_popup_inner h3');
                  $(overlay + ' .close_window').hide();
                  openOverlay();
                }
            }

            // prevent everything and show overlay
            $(previewbutton, context).one('form_popup_click').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                openOverlay();
            });

            function openOverlay() {
                $(overlay).fadeIn();
                $('body').addClass('overlay-open');

              $(overlay).attr('aria-hidden', 'false');
              $('body').attr('aria-hidden', 'true');

              releaseFocus = trapFocus($(overlay));

              if ($('.overlay_popup_inner').length >= 1) {
                $('.overlay_popup_inner').focus();
              }
                $('html').animate({
                    scrollTop: $(".overlay_popup").offset().top
                }, 300);
            }

            // prevent everything
            $(previewbutton, context).one('form_popup_down').mousedown(function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            });

            // Close Popup
          $('.overlay_popup .close-button').on('click', function () {
            $('body').removeClass('overlay-open');
            $('.overlay_popup').css('display', 'none');

            $('.overlay_popup').attr('aria-hidden', 'true');
            $('body').attr('aria-hidden', 'false');

            if (releaseFocus) releaseFocus();
            $('#openPopup').focus();

          });

        }
    };

  function trapFocus($container) {
    const focusable = $container.find('a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])');
    const first = focusable.first();
    const last = focusable.last();

    $container.on('keydown.trapFocus', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first[0]) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last[0]) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    });

    first.focus();

    // Return cleanup function
    return function releaseFocus() {
      $container.off('keydown.trapFocus');
    };
  }

})(jQuery, Drupal);
